import { DetailsRow } from '@/components/DetailsWidget/DetailsRow/DetailsRow';
import { DetailsWidget } from '@/components/DetailsWidget/DetailsWidget';
import { formatDate, FULL_DATE_TIME_FORMAT } from '@/helpers/dateHelpers/dateHelpers';
import { AuditEventDetailsType, AuditEventType } from '@/types/auditLogTypes';
import { SOURCE_LABEL } from '../const/const';
import { Mono } from '../styles';

type AuditEventDetailsWidgetType = {
  event: AuditEventType;
  isLoading: boolean;
  details: AuditEventDetailsType;
};

export const AuditEventDetailsWidget = ({ event, details, isLoading }: AuditEventDetailsWidgetType) => {
  return (
    <DetailsWidget header={event.event} isLoading={isLoading} marker={SOURCE_LABEL[event.source]?.toUpperCase()}>
      <DetailsRow name='When'>{formatDate(event.date_created, FULL_DATE_TIME_FORMAT)}</DetailsRow>
      <DetailsRow name='Category'>{event.category_label}</DetailsRow>
      <DetailsRow name='Actor'>
        {event.actor_label}
        {event.actor_role ? ` (${event.actor_role})` : ''}
      </DetailsRow>
      <DetailsRow name='Object'>
        {event.object_label || '-'}
        {event.object_type ? ` · ${event.object_type}` : ''}
      </DetailsRow>
      {event.transaction_ref && (
        <DetailsRow name='Transaction ID'>
          <Mono>{event.transaction_ref}</Mono>
        </DetailsRow>
      )}
      <DetailsRow name='Detail' title={event.detail}>
        {event.detail || '-'}
      </DetailsRow>
      {details && (
        <>
          <DetailsRow name='IP address'>
            <Mono>{details.ip || '-'}</Mono>
          </DetailsRow>
          <DetailsRow name='Device' title={details.user_agent}>
            {details.user_agent || '-'}
          </DetailsRow>
          {details.http_method && (
            <DetailsRow name='Request'>
              <Mono>
                {details.http_method} {details.path}
              </Mono>
            </DetailsRow>
          )}
          {details.screen && <DetailsRow name='Screen'>{details.screen}</DetailsRow>}
          <DetailsRow name='Request ID'>
            <Mono>{details.request_id || '-'}</Mono>
          </DetailsRow>
        </>
      )}
    </DetailsWidget>
  );
};
